export default "__VITE_ASSET__C56oRIbw__ 720w";